module.exports = "<span><span ng-repeat=\"flightPoint in ::flightRouteCtrl.flightRoute\"><i class=i-cm-rarr ng-if=!$first></i> <span ng-if=::flightRouteCtrl.showFullInfo>{{::flightPoint.airportCity}} ({{::flightPoint.airportCode}})</span> <span ng-if=::!flightRouteCtrl.showFullInfo>{{::flightPoint[flightRouteCtrl.showOnlyValue]}}</span></span></span>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/trip/directives/templates/ktFlightRoute.tmpl.html
// module id = 3540
// module chunks = 0